import { Filters as BaseFilters, TFiltersProps as TBaseFiltersProps, TSelectValue } from '@chocolate-soup-inc/cs-frontend-components';
import { useEffect, useMemo } from 'react';
import { useFilter } from '../../contexts/filters';

export type TFilterExpressionObject = {
  key: string;
  value: any;
};

export type TFiltersProps = TBaseFiltersProps;

export const Filters = ({ filters }: TFiltersProps) => {
  const { setFilters, setFiltersUpdaters, onFilterChange } = useFilter();

  useEffect(() => {
    const allowedFilters = filters.flatMap((filter) => (filter.name && filter.onChange ? [filter.name] : []));
    const allowedFiltersUpdaters = Object.fromEntries(filters.flatMap((filter) => (filter.name && filter.onChange ? [[filter.name, filter.onChange]] : [])));

    setFilters(allowedFilters);
    setFiltersUpdaters(allowedFiltersUpdaters);
  }, [filters, setFilters, setFiltersUpdaters]);

  const contextFilters = useMemo<TFiltersProps['filters']>(() => {
    return filters.map((filter) => {
      const contextFilter = {
        ...filter,
        onChange: (value: TSelectValue) => {
          if (filter.name) onFilterChange(filter.name, (value as string) ?? '');
        }
      };

      if (contextFilter.type === 'singleSelect') contextFilter.includeEmptyOption ??= true;

      return contextFilter;
    }) as TFiltersProps['filters'];
  }, [filters, onFilterChange]);

  return <BaseFilters filters={contextFilters} />;
};
